import React, { ReactNode, useEffect, useRef } from 'react';
import { Icon } from '../../../../../../../base/components/Icon';

import './styles.scss';

interface Props {
    showTooltip: boolean;
    activeButton: ReactNode;
    children: ReactNode;
    className?: string;
    wrapperClassName?: string;
    align?: 'left' | 'center' | 'right';
    closeTooltipHandler: () => void;
}

export const ErrorTooltip = ({ showTooltip, activeButton, children, align = 'center', closeTooltipHandler }: Props) => {
    const tooltipRef = useRef<HTMLDivElement>(null);
    const tooltipButton = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (tooltipRef && tooltipRef.current && tooltipButton && tooltipButton.current) {
            const tooltipWidth = tooltipRef.current.offsetWidth;
            const tooltipButtonWidth = tooltipButton.current.offsetWidth;
            const tooltipButtonHeight = tooltipButton.current.offsetHeight;
            tooltipRef.current.style.bottom = `calc(${tooltipButtonHeight}px + 12px)`;

            switch (align) {
                case 'left':
                    tooltipRef.current.style.left = '0px';
                    break;
                case 'right':
                    tooltipRef.current.style.right = '0px';
                    break;
                case 'center':
                default:
                    tooltipRef.current.style.left = `calc(-1 * ((${tooltipWidth}px - ${tooltipButtonWidth}px) / 2))`;
                    break;
            }
        }
    }, [tooltipRef, tooltipButton, align]);

    return (
        <div className={'responses-invitation-error-tooltip'}>
            <div className='responses-invitation-error-tooltip__activate-button' ref={tooltipButton}>
                {activeButton}
            </div>

            {showTooltip && (
                <div className='responses-invitation-error-tooltip__overlay' onClick={closeTooltipHandler}></div>
            )}

            <div
                className={`responses-invitation-error-tooltip__popup-container ${
                    showTooltip ? 'responses-invitation-error-tooltip__popup-container--visible' : ''
                } `}
                ref={tooltipRef}
            >
                {children}
                <div className='responses-invitation-error-tooltip__close' onClick={closeTooltipHandler}>
                    <Icon icon='xmark-regular' />
                </div>
            </div>
        </div>
    );
};
